import max from 'lodash.max';

export const dataToOutcome = ({data}) => {
  const outcome = [];

  for (let i = 1; i < data.length; i += 1) {
    const seasons = data[i];
    const item = {};

    Object.keys(seasons).forEach(season => {
      if (i === 1) {
        item[season] = 0;
      } else {
        const prevOutcome = outcome[i - 2][season];
        const {r, o} = data[i][season];
        item[season] = prevOutcome + (r === 1 ? r * o * 100 - 100 : -100);
      }
    });

    outcome.push(item);
  }

  return outcome;
};

export const seasonsBacktestingToData = seasons => {
  const data = [];
  const maxBetsAmount = max(seasons.map(season => season.data.length));

  /* convert structure
    [
      {"name":"2018", "data":[{"t":1548536400000,"r":-1,"o":2.87}], ...},
      {"name":"2019", "data":[{"t":1518213600000,"r":-1,"o":2.79}], ...},
    ]
    to -> [{2018: {r, o, t}, 2019: {r, o, t}}, {2018: {r, o, t}, 2019: {r, o, t}}, {2018: {r, o, t}}]
  */
  for (let i = -1; i < maxBetsAmount; i += 1) {
    const item = {};
    seasons.forEach(season => {
      if (i === -1) {
        item[season.name] = 0; // set starting point
      } else {
        const bet = season.data[i];
        if (bet) {
          item[season.name] = {
            r: bet.r,
            o: bet.o,
            t: bet.t,
          };
        }
      }
    });
    data.push(item);
  }

  return data;
};
